/**
 * Mobile menu
 * Javascript functionality for a (mobile) menu.
 * @version 3.0.0
 * @exports MobileMenu
 */
export default class MobileMenu {
	/**
	 * Constructor
	 * @public
	 */
	constructor() {
		this.body = document.getElementsByTagName('BODY')[0];

		// Side-menu elements
		this.sideMenuBtn = document.getElementById('side-menu-button');
		this.sideMenuClose = document.getElementById('side-menu-close');
		this.sideMenu = document.getElementById('side-menu');
		this.pageCover = document.getElementById('side-menu-page-cover');

		// Mobile-menu elements
		this.mobileMenuBtn = document.getElementById('mobile-menu-button');
		this.mobileMenu = document.getElementById('mobile-menu');

		// Search-pane elements
		this.searchBtn = document.getElementById('search-button');
		this.searchPane = document.getElementById('search-pane');

		this._initSideMenu();
		this._initMobileMenu();
		this._initSearchPane();
	}

	/**
	 * Opens the menu.
	 * @public
	 */
	openPane(pane, button) {
		pane.style.display = 'block';

		if (
			pane.getAttribute('id') === 'mobile-menu' ||
			pane.getAttribute('id') === 'side-menu'
		) {
			setTimeout(() => {
				this.body.classList.add('nav-open');
				this.body.classList.add('nav-is-visible');
			}, 50);
		}

		if (pane.getAttribute('id') === 'search-pane') {
			setTimeout(() => {
				button.classList.remove('icon-search');
				button.classList.add('icon-x');
				this.body.classList.add('search-open');
				this.body.classList.add('search-is-visible');
			}, 50);
		}

		setTimeout(() => {
			pane.setAttribute('aria-hidden', false);
			button.setAttribute('aria-expanded', true);
		}, 50);
	}

	/**
	 * Closes the menu.
	 * @public
	 */
	closePane(pane, button) {
		if (
			pane.getAttribute('id') === 'mobile-menu' ||
			pane.getAttribute('id') === 'side-menu'
		) {
			this.body.classList.remove('nav-open');
			setTimeout(() => {
				this.body.classList.remove('nav-is-visible');
			}, 100);
		}

		if (pane.getAttribute('id') === 'search-pane') {
			button.classList.remove('icon-x');
			button.classList.add('icon-search');
			this.body.classList.remove('search-open');
			this.body.classList.remove('search-is-visible');
		}

		pane.setAttribute('aria-hidden', true);
		button.setAttribute('aria-expanded', false);
		setTimeout(() => {
			pane.style.display = 'none';
		}, 450);
	}

	/**
	 * Function that initiate the mobile menu.
	 * @private
	 */

	_initMobileMenu() {
		if (this.mobileMenuBtn) {
			this.mobileMenuBtn.addEventListener('click', e => {
				e.preventDefault();

				if (this.body.classList.contains('nav-open')) {
					this.closePane(this.mobileMenu, this.mobileMenuBtn);
				} else if (this.body.classList.contains('search-open')) {
					this.closePane(this.searchPane, this.searchBtn);
					this.openPane(this.mobileMenu, this.mobileMenuBtn);
				} else {
					this.openPane(this.mobileMenu, this.mobileMenuBtn);
				}
			});
		}
	}

	/**
	 * Function that initiate the side menu on desktop.
	 * @private
	 */
	_initSideMenu() {
		if (this.sideMenuBtn) {
			this.sideMenuBtn.addEventListener('click', e => {
				e.preventDefault();

				if (this.body.classList.contains('search-open')) {
					this.closePane(this.searchPane, this.searchBtn);
				}
				this.openPane(this.sideMenu, this.sideMenuBtn);
			});
		}

		if (this.sideMenuClose) {
			this.sideMenuClose.addEventListener('click', e => {
				e.preventDefault();
				this.closePane(this.sideMenu, this.sideMenuBtn);
			});
		}

		if (this.pageCover) {
			this.pageCover.addEventListener('click', e => {
				e.preventDefault();
				this.closePane(this.sideMenu, this.sideMenuBtn);
			});
		}
	}

	/**
	 * Function that initiate the search pane.
	 * @private
	 */
	_initSearchPane() {
		if (this.searchBtn) {
			this.searchBtn.addEventListener('click', e => {
				e.preventDefault();

				if (this.body.classList.contains('search-open')) {
					this.closePane(this.searchPane, this.searchBtn);
				} else if (this.body.classList.contains('nav-open')) {
					this.closePane(this.mobileMenu, this.mobileMenuBtn);
					this.openPane(this.searchPane, this.searchBtn);
				} else {
					this.openPane(this.searchPane, this.searchBtn);
				}
			});
		}
	}
}
